import { hrmsGet, hrmsPost, hrmsPut } from "../api/api";
import { getInitialFormState } from "../modules/holiday-management/constants/formState";
import sessionDB from "../utils/sessionDB";

export { getInitialFormState };

function getCategoryIdByName(categories, name) {
  return categories.find((c) => c.categoryName === name)?.categoryId;
}

function getCategoryNameById(categories, id) {
  return categories.find((c) => c.categoryId === id)?.categoryName;
}

async function buildEventPayload(formState, { forUpdate = false } = {}) {
    const result = await fetchHoliday();
    const categories = Array.isArray(result) ? result : result?.data ?? [];
  return {
    title: formState.title,
    description: formState.description,
    categoryId: getCategoryIdByName(categories, formState.type),
    startTime: formState.start + "T" + (formState.startTime || "00:00") + ":00",
    endTime: formState.end + "T" + (formState.endTime || "23:59") + ":00",
    isAllDay: formState.allDay,
    isEnabled: formState.isEnabled !== undefined ? formState.isEnabled : true,
    visibilityScope:
      formState.visibility === "Work Location" ? "Location" : formState.visibility,
   departmentId: formState.visibility === "Department"
     ? formState.scopeValues[0]
     : null,
   workLocationId: formState.visibility === "Work Location"
     ? formState.scopeValues[0]
     : null,

  };
}

function mapServerEvent(event,categories) {
 return {
   id: event.eventId,
   title: event.title,
   description: event.description,
   type: getCategoryNameById(categories, event.categoryId),

   start: event.startTime.split("T")[0],
   end: event.endTime.split("T")[0],

   startDay: event.startDay,
   endDay: event.endDay,

   startTime: event.startTime.split("T")[1]?.slice(0, 5),
   endTime: event.endTime.split("T")[1]?.slice(0, 5),

   allDay: event.isAllDay,

   visibility:
     event.visibilityScope === "Location"
       ? "Work Location"
       : event.visibilityScope,

   scopeValues: event.departmentId
     ? [event.departmentId]
     : event.workLocationId
       ? [event.workLocationId]
       : [],


 };
}

/** POST /org-calendar-events/add — X-Service-Code: HR14A */
export async function createEventOnServer(formState) {
  const payload = await buildEventPayload(formState, { forUpdate: false });
  return hrmsPost("/org-calendar-events/add", payload, "HR14A");
}

/**
 * PUT /org-calendar-events/update/{id} — X-Service-Code: HR14A
 * (Preserves original holiday-managerc header behavior.)
 */
export async function updateEventOnServer(formState) {
  const payload = await buildEventPayload(formState, { forUpdate: true });
  return hrmsPut(`/org-calendar-events/update/${formState.id}`, payload, "HR14A");
}

/** GET /org/work-locations?tenantId=1 — HR14A */
export async function fetchWorkLocations() {
  const tenantId = sessionDB.getTenantId();
  return hrmsGet(`/org/work-locations?tenantId=${tenantId}`, "HR14A");
}

/** GET /org/departments?tenantId=1 — HR14A */
export async function fetchDepartments() {
  const tenantId = sessionDB.getTenantId();
  return hrmsGet(`/org/departments?tenantId=${tenantId}`, "HR14A");
}

/** GET /org/calendar-categories?tenantId=1 — HR14A */
export async function fetchHoliday() {
  const tenantId = sessionDB.getTenantId();
  return hrmsGet(`/org/calendar-categories?tenantId=${tenantId}`, "HR14A");
}

/**
 * GET /org-calendar-events/search/upcoming?page=0&size=100&sortBy=startTime&sortDir=ASC
 * X-Service-Code: HR14U
 */
export async function fetchAllEvents() {

  const result = await hrmsGet(
    "/org-calendar-events/search/upcoming?page=0&size=1000&sortBy=startTime&sortDir=ASC",
    "HR14U"
  );
  const content = result?.data?.content ?? [];
  const catResult = await fetchHoliday();
  const categories = Array.isArray(catResult) ? catResult : catResult?.data ?? [];
  return content.map((event) => mapServerEvent(event, categories));
}

export async function fetchCategoryByName(categoryName) {
  return hrmsGet(
    `/org-calendar-categories/name/${encodeURIComponent(categoryName)}`,
    "HR14A"
  );
}

export async function fetchEventsByCategory(categoryId, categories) {
  const result = await hrmsGet(
    `/org-calendar-events/search/category/${categoryId}?page=0&size=10&sortBy=startTime&sortDir=ASC`,
    "HR14U"
  );

  const content = result?.data?.content ?? [];

  return content.map((event) =>
    mapServerEvent(event, categories)
  );
}